import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';

export default function ConsentPreviewDialog({ html, onClose }: { html: string | null; onClose: () => void }) {
  if (!html) return null;
  return <Dialog open onClose={onClose} fullWidth maxWidth="lg" aria-labelledby="consent-preview-title"
    PaperProps={{ sx: { borderRadius: '16px', height: '90dvh', maxHeight: 'calc(100dvh - 32px)', m: 2 } }}>
    <DialogTitle id="consent-preview-title" sx={{ pr: 7 }}>Consent form preview</DialogTitle>
    <IconButton aria-label="Close consent preview" onClick={onClose} sx={{ position: 'absolute', top: 12, right: 12 }}><Close /></IconButton>
    <DialogContent dividers sx={{ p: 0, display: 'flex' }}>
      <Box component="iframe" title="Consent form content" srcDoc={html} sandbox="" referrerPolicy="no-referrer"
        sx={{ width: '100%', height: '100%', border: 0, bgcolor: 'white' }} />
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', py: 1.5 }}><Button onClick={onClose}>Close preview</Button></DialogActions>
  </Dialog>;
}
